import styled from "styled-components";

export const SFileUploadEmptyIconContainer = styled.div`
  height: 56px;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--ui-03);
  border-radius: 50%;
  color: var(--icon-01);
`;
